import { useRef, type FC } from 'react';
import type { AiCover } from './type';
import { Button } from '@flowus/common/components';
import { Icon } from 'src/common/components/icon';
import html2canvas from '@flowus/html2canvas';
import dayjs from 'dayjs';
import { downloadUrlFile } from 'src/common/utils/download-utils';
import { LoadingContainer } from 'src/common/components/loading-container';
import { AiCoverStore, setAiCoverStore } from './store';
import { stopAICover } from './uitl';

export const CoverPanel: FC<AiCover> = (props) => {
  return (
    <div className="w-full h-auto bg-aside">
      {props.loading ? <Loading /> : props.html ? <HTMLDisplay html={props.html} /> : <Empty />}
    </div>
  );
};
const Loading: FC = () => {
  const message = AiCoverStore((state) => state.message);
  return (
    <LoadingContainer
      description={
        <div className="flex flex-col items-center">
          <div>{message ?? '正在生成...'}</div>
          <Button
            className="mt-1"
            onClick={() => {
              stopAICover();
              setAiCoverStore({ loading: false, message: '', html: '' });
            }}
          >
            停止
          </Button>
        </div>
      }
      descriptionClassName="text-grey3"
    />
  );
};

const HTMLDisplay: FC<Pick<AiCover, 'html'>> = (props) => {
  const dom = useRef<HTMLDivElement>(null);

  const save = async () => {
    if (!dom.current) return;
    const canvas = await html2canvas(dom.current, {
      useCORS: true,
      scale: 1,
    });
    const url = canvas.toDataURL('image/png', 100);
    const day = dayjs().format('YYYY_MM_DD_HH_mm');
    void downloadUrlFile(url, `封面${day}.png`);
  };
  return (
    <div
      className="relative flex justify-center overflow-auto"
      style={{
        scrollbarWidth: 'none',
      }}
    >
      <div className="h-[537px]">
        <div ref={dom} dangerouslySetInnerHTML={{ __html: props.html }}></div>
      </div>
      <div className="fixed right-5 top-20">
        <Button className="px-2" onClick={save}>
          <Icon name="IcDownload" size="xsmall" className="text-grey2" />
          <span className="text-grey2 text-t2 ml-1">保存</span>
        </Button>
      </div>
    </div>
  );
};

const Empty: FC = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full w-full">
      <img src="https://cdn2.flowus.cn/public/512d9d30-aa4c-43bc-b3f0-441b0b1a14be/amen.svg" />
      <div className="mt-6 text-grey3 text-t2-medium">试试生成海报</div>
    </div>
  );
};
